export const VouchTokens = {
  colors: {
    navy: "#0B1F3B",
    teal: "#18B6B2",
    white: "#FFFFFF",
    ink: "#0A0F1A",
    muted: "#6B7280",
  },
  logo: {
    clearspaceRatio: 0.25,
    minSizePx: { icon: 24, wordmark: 120 },
  },
};

// Reward paid to voucher per successful hire
export const VOUCH_REWARD = 500;
